export class MissingParameterError extends Error {
  constructor(parameters: string[]) {
    const [first, ...rest] = parameters
    const last = rest.pop()

    if (!first) {
      throw new TypeError("MissingParameterError: No parameters provided.")
    } else if (!last) {
      super(`${first} is a required parameter for this request.`)
    } else {
      super(
        `${first}${rest.length ? `, ${rest.join(", ")}` : ""} and ${last} are required parameters for this request.`,
      )
    }
  }
}
